import React, { useState, useEffect } from "react";
import { orderInvoiceGetClientInfo } from "../../../../../../redux/Actions/order_invoice_action";
import Spinner from "../../../../Spinner";
import TextInputModal from "../../../../TextInputModal";
import TextAreaFieldGroup from "../../../../TextAreaFieldGroup";

const ForwardProformaInvoice = ({
  order_id,
  forwardProformaData,
  setForwardProformaData,
}) => {
  console.log({ order_id });
  useEffect(() => {
    if (!order_id) return;
    setLoading(true);
    orderInvoiceGetClientInfo(order_id).then((res) => {
      if (res.success) {
        setForwardProformaData({
          email: res.email,
          message: res.message,
          subject: res.subject,
        });
      }
      setLoading(false);
    });
  }, [order_id]);

  const [loading, setLoading] = useState(false);
  if (loading) {
    return <Spinner />;
  }
  const onChange = (e) => {
    const { name, value } = e.target;
    setForwardProformaData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const { email, subject, message } = forwardProformaData;
  return (
    <div className="mt-2">
      <TextInputModal
        type="email"
        text="Customer email"
        name="email"
        value={email}
        onChange={onChange}
      />
      <TextInputModal
        text="Subject"
        name="subject"
        value={subject}
        onChange={onChange}
      />
      <TextAreaFieldGroup
        placeholder="Message"
        onlyPlaceholder="Enter"
        value={message}
        onChange={onChange}
      />
    </div>
  );
};

export default ForwardProformaInvoice;
